export function FileBgIcon({
  className = "",
}: {
  className?: string;
}) {
  return (
    <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <g clip-path="url(#clip0_2663_29917)">
        <g filter="url(#filter0_di_2663_29917)">
          <path d="M45 60H15C10.0294 60 6 55.9706 6 51V9C6 4.02944 10.0294 0 15 0H30.7721C33.159 0 35.4482 0.948214 37.136 2.63604L51.364 16.864C53.0518 18.5518 54 20.841 54 23.2279V51C54 55.9706 49.9706 60 45 60Z" fill="white" />
          <path d="M15 1H30.7725C32.8939 1.0001 34.9285 1.84276 36.4287 3.34277L50.6572 17.5713C52.1572 19.0715 52.9999 21.1061 53 23.2275V51C53 55.4183 49.4183 59 45 59H15C10.5817 59 7 55.4183 7 51V9C7 4.58172 10.5817 1 15 1Z" stroke="#D0D5DD" stroke-width="2" />
        </g>
        <path d="M34.5 1.5V13.5C34.5 16.8137 37.1863 19.5 40.5 19.5H52.5" stroke="#D0D5DD" stroke-width="2" />
      </g>
      <defs>
        <filter id="filter0_di_2663_29917" x="3" y="-6" width="54" height="70.5" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="1.5" />
          <feGaussianBlur stdDeviation="1.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.894118 0 0 0 0 0.898039 0 0 0 0 0.905882 0 0 0 0.24 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2663_29917" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2663_29917" result="shape" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="-6" />
          <feGaussianBlur stdDeviation="3" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.813571 0 0 0 0 0.82 0 0 0 0 0.826429 0 0 0 0.32 0" />
          <feBlend mode="normal" in2="shape" result="effect2_innerShadow_2663_29917" />
        </filter>
        <clipPath id="clip0_2663_29917">
          <rect width="60" height="60" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
export const displayName = "FileBgIcon";
